import { watchValues } from '@dbk-legacy/muster/utils';
import orderBy from 'lodash/orderBy';

function sortableList({ fromPath, toPath, sortByKey, isAscending }) {
  if (!fromPath || !toPath || !sortByKey || !isAscending) return;

  return ({ res }, { get }) => {
    return watchValues(get([fromPath, sortByKey, isAscending]))
      .map(([list, sortBy, ascending]) => {
        let value = list;

        if (sortBy !== false) {
          value = orderBy(
            value,
            sortBy,
            ascending ? 'asc' : 'desc',
          );
        }

        return {
          path: toPath,
          value,
        };
      })
  }
}

export default sortableList;